module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"bankValidationError":"Debes elegir un banco","passwordValidationError":"Debes ingresar tu clave","idNumberError":"Debes ingresar un rut correcto","cardCodeValidationError":"Coordenadas inválidas","smsValidationError":"Clave inválida"}}')
  delete Component.options._Ctor
}
